import { render, staticRenderFns } from "./TFormGroup.vue?vue&type=template&id=214386fe&scoped=true&"
import script from "./TFormGroup.vue?vue&type=script&lang=js&"
export * from "./TFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./TFormGroup.vue?vue&type=style&index=0&id=214386fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214386fe",
  null
  
)

export default component.exports